export default "__VITE_ASSET__ca60fe00__"